export var tabbables = [
    'button:enabled',
    'select:enabled',
    'textarea:enabled',
    'input:enabled',
    'a[href]',
    'area[href]',
    'summary',
    'iframe',
    'object',
    'embed',
    'audio[controls]',
    'video[controls]',
    '[tabindex]',
    '[contenteditable]',
    '[autofocus]',
];



//////////////////
// WEBPACK FOOTER
// ./node_modules/focus-lock/dist/es2015/utils/tabbables.js
// module id = 1389
// module chunks = 0